import { render, staticRenderFns } from "./ProductAdditionalRelation.vue?vue&type=template&id=310f94c9"
import script from "./ProductAdditionalRelation.vue?vue&type=script&lang=js"
export * from "./ProductAdditionalRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports